import actions from './actions';
import reducer from './reducer';

const rxRenewal = {
    actions,
    reducer,
    name: 'rxRenewal',
};

export default rxRenewal; 